<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">
				<template v-if="auxiliary">{{auxiliary.name}}</template><template v-if="auxiliaryItem">:{{auxiliaryItem.name}}</template> 明细账</span>
		</div>
		<Row type="flex" :space-x="10" class="margin-right-left margin-top no-print">
			<Cell>
				<account-date-choose v-model="accountDate"/>
			</Cell>
			<Cell>
				<span class="range-sep">至</span>
				<DatePicker type="month" v-model="endMonth" format="YYYY-MM" placeholder="结束月份(可选)" :clearable="true" style="width: 130px;"></DatePicker>
			</Cell>
			<Cell class="label">辅助类别：</Cell>
			<Cell>
				<Select type="object" v-model="auxiliary" :deletable="false" style="min-width: 100px" :datas="auxiliaryType" keyName="id" titleName="name"/>
			</Cell>
			<Cell>
				<Button :disabled="!auxiliary" :loading="loading" color="primary" @click="doSearch">查询</Button>
			</Cell>
			<Cell>
				<Button icon="fa fa-download" @click="doExport">导出</Button>
				<Button icon="fa fa-print" @click="doPrint">打印</Button>
			</Cell>
			<Cell :flex="1"></Cell>
		</Row>
		<Row class="h-panel-body" type="flex" :space-x="10">
			<Cell :flex="1">
				<div class="print-header">
					<div class="print-title">
						<template v-if="auxiliary">{{auxiliary.name}}</template><template v-if="auxiliaryItem">:{{auxiliaryItem.name}}</template> 明细账</div>
					<div class="print-sub">
						<span>编制单位：{{currentAccountSets?currentAccountSets.companyName:''}}</span>
						<span>期间：{{printPeriod}}</span>
						<span>单位：元</span>
					</div>
				</div>
				<Table :datas="dataList" :border="true" :loading="loading">
					<TableItem title="日期" prop="voucherDate" :width="85"></TableItem>
					<TableItem title="凭证字号" :width="85">
						<template slot-scope="{data}" v-if="data.word">
							<router-link :to="{name:'VoucherForm',params:{voucherId:data.voucherId}}">{{data.word}}-{{data.code}}</router-link>
						</template>
					</TableItem>
					<TableItem title="摘要" prop="summary"></TableItem>
					<TableItem title="借方" align="right" :width="85">
						<template slot-scope="{data}">
							{{data.debitAmount|numFormat}}
						</template>
					</TableItem>
					<TableItem title="贷方" align="right" :width="85">
						<template slot-scope="{data}">
							{{data.creditAmount|numFormat}}
						</template>
					</TableItem>
					<TableItem title="方向" prop="balanceDirection" align="center" :width="50"></TableItem>
					<TableItem title="余额" align="right" :width="85">
						<template slot-scope="{data}">
							{{data.balance|numFormat}}
						</template>
					</TableItem>
				</Table>
			</Cell>
			<Cell v-width="200" class="no-print">
				<Tree @select="doSelect" :option="param" ref="auxiliary" filterable selectOnClick className="h-tree-theme-row-selected"></Tree>
			</Cell>
		</Row>
	</app-content>
</template>

<script>
	import moment from 'moment';
	import {mapState} from 'vuex';
	import {exportCsv} from '../../js/common/export-file';

	export default {
		name: "AuxiliaryAccountingDetail",
		data() {
			return {
				dataList: [],
				loading: false,
				showNumPrice: false,
				param: {
					keyName: 'id',
					parentName: 'parentId',
					titleName: 'name',
					dataMode: 'list',
					datas: []
				},
				accountDate: null,
				endMonth: null,
				auxiliary: null,
				auxiliaryItem: null,
				auxiliaryType: [],
				//从辅助余额表联查跳转时待定位的类别与项目
				pendingAuxiliaryId: null,
					pendingItemCode: null
				}
			},
			computed: {
				...mapState(['currentAccountSets']),
				printPeriod() {
					if (!this.accountDate) {
						return '';
					}
					let s = moment(this.accountDate).format('YYYY年MM月');
					if (this.endMonth && moment(this.endMonth, 'YYYY-MM').isAfter(moment(this.accountDate), 'month')) {
						s += ' 至 ' + moment(this.endMonth, 'YYYY-MM').format('YYYY年MM月');
					}
					return s;
				}
			},
		methods: {
			loadAuxiliaryType() {
				this.$api.setting.accountingCategory.list().then(({data}) => {
					this.auxiliaryType = data;
					//联查定位辅助类别并自动查询
					if (this.pendingAuxiliaryId) {
						let t = data.find(a => String(a.id) === String(this.pendingAuxiliaryId));
						this.pendingAuxiliaryId = null;
						if (t) {
							this.auxiliary = t;
							this.loadAuxiliaryList();
						}
					}
				});
			},
			loadList() {
				if (!this.auxiliary || !this.auxiliaryItem) {
					return;
				}
				this.loading = true;
				let params = {
					accountDate: this.accountDate,
					auxiliaryId: this.auxiliary.id,
					auxiliaryItemId: this.auxiliaryItem.id,
				};
				if (this.endMonth && moment(this.endMonth, 'YYYY-MM').isAfter(moment(this.accountDate), 'month')) {
					params.endAccountDate = moment(this.endMonth, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
				}
				this.$api.accountbook.loadAuxiliaryDetails(params).then(({data}) => {
					this.dataList = data;
				}).finally(() => {
					this.loading = false;
				});
			},
			loadAuxiliaryList() {
				if (!this.auxiliary) {
					return;
				}
				this.dataList = [];
				this.$api.accountbook.loadAuxiliaryList({
					auxiliaryId: this.auxiliary.id
				}).then(({data}) => {
					data.forEach(val => val.name = val.code + " " + val.name);
					data = data.sort((a, b) => a.code.localeCompare(b.code));
					this.$set(this.param, "datas", data);
					if (data.length) {
						let target = null;
						//联查定位核算项目
						if (this.pendingItemCode) {
							target = data.find(v => v.code === this.pendingItemCode);
							this.pendingItemCode = null;
						}
						this.auxiliaryItem = target || data[0];
						this.loadList();
						this.$nextTick(() => {
							this.$refs.auxiliary.updateSelect(this.auxiliaryItem.id);
						});
					}
				});
			},
			doSearch() {
				this.loadAuxiliaryList();
			},
			doSelect(node) {
				this.auxiliaryItem = node;
				this.loadList();
			},
			doExport() {
				if (!this.dataList.length) {
					this.$Message.error('暂无数据可导出');
					return;
				}
				let name = (this.auxiliary ? this.auxiliary.name : '核算项目')
					+ (this.auxiliaryItem ? '-' + this.auxiliaryItem.name : '');
				let headers = ['日期', '凭证字号', '摘要', '借方', '贷方', '方向', '余额'];
				let rows = this.dataList.map(item => [
					item.voucherDate ? moment(item.voucherDate).format('YYYY-MM-DD') : '',
					item.word && item.code ? item.word + '-' + item.code : '',
					item.summary, item.debitAmount, item.creditAmount,
					item.balanceDirection, item.balance
				]);
				exportCsv(name + '明细账' + (this.accountDate ? '-' + moment(this.accountDate).format('YYYYMM') : '') + (this.endMonth ? '-' + moment(this.endMonth, 'YYYY-MM').format('YYYYMM') : ''), headers, rows);
			},
			doPrint() {
				window.print();
			}
		},
		mounted() {
			//辅助余额表联查入口：接收类别、项目与期间参数
			let q = this.$route.query || {};
			if (q.auxiliaryId) {
				this.pendingAuxiliaryId = q.auxiliaryId;
			}
			if (q.itemCode) {
				this.pendingItemCode = q.itemCode;
			}
			if (q.endMonth) {
				this.endMonth = q.endMonth;
			}
			if (q.accountDate && q.accountDate !== this.accountDate) {
				this.accountDate = q.accountDate;
			}
			this.loadAuxiliaryType();
		}
	}
</script>

<style scoped>
	.range-sep {
		margin: 0 8px;
		line-height: 30px;
		vertical-align: middle;
	}
</style>